export default {
  label: {
    replierName: 'Attendant',
    rating: 'Rating',
    viewRating: 'Open rating',
    button: {
      view: 'Open publication',
      apply: 'Apply filters',
      clear: 'Clear filters',
    },
    table: {
      header: {
        userName: 'User',
        surveyScore: 'Rating',
        surveyComment: 'Comment',
        replierName: 'Attendant',
        responseAt: 'Rating Date',
        seeRating: 'View Rating',
      },
    },
  },
  faq: {
    title: 'What is it?',
    description: 'List of ratings and comments that each user made within the Satisfaction Survey.',

    faq01: {
      title: 'How do I filter ratings?',
      description: 'The star position that will be filled when clicked will be filtered, for example, first and third positions filled: only ratings of 1 and 3 stars will appear.',
    },
    faq02: {
      title: 'Is it possible to get the list of ratings for specific operators?',
      description: 'Yes, it is possible to filter by user, which will list all ratings from the specific respondent.',
    },
  },
};
